import * as React from "react";
import { DividerContainer } from "./Divider.styled";

interface DividerProps {}

export const Divider = ({}: DividerProps) => {
	return <DividerContainer />;
};
